import React from 'react';
import { View, Image, ScrollView } from 'react-native';
import Label from '../../common/Label';
import useTranslation from '../../../hooks/translation-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import { getOnboardingPalette } from '../onboardingPalette';

const OnboardingMobileOne = () => {
  const t = useTranslation({ defaultPath: 'onboarding.page1' });
  const theme = useCustomTheme();
  const palette = getOnboardingPalette(0, !!theme.isDark);
  return (
    <View style={{ flexGrow: 1, backgroundColor: palette.backgroundColor }}>
      <Image {...({ pointerEvents: 'none' } as any)} source={require('../../../../assets/onBoarding_mobile_1.png')} style={{ aspectRatio: '350/234', width: '100%', height: 'auto' }} />
      <View style={{ flexGrow: 1, marginTop: 8 }}>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{ flexGrow: 1, paddingLeft: 12, paddingRight: 12, paddingBottom: 42 }}
          scrollEnabled={true}
          showsVerticalScrollIndicator={true}
          nestedScrollEnabled={true}
          bounces={false}
          overScrollMode="never"
        >
          <View style={{ width: '100%' }}>
            <Label style={{ fontSize: 28, color: palette.titleColor, fontWeight: '600', width: 250 }} numberOfLines={20}>
              {t('title')}
            </Label>
            <Label style={{ marginTop: 20, fontSize: 18, color: palette.subtitleColor, fontWeight: '400', width: 250 }} numberOfLines={20}>
              {t('subtitle')}
            </Label>
            <Label style={{ fontSize: 15, marginTop: 16, color: palette.bodyColor }} numberOfLines={200}>
              {t('description')}
            </Label>
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default OnboardingMobileOne;
